export const config = {
  API_BASE_URL: 'https://api.cineblocks.com.br',
  // API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
  APP_NAME: import.meta.env.VITE_APP_NAME || 'CineBlocks',
  NODE_ENV: import.meta.env.VITE_NODE_ENV || 'development',
  IS_UAT: import.meta.env.VITE_NODE_ENV === 'uat'
};